import { apiFetch } from './client';

export const getRisks = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return apiFetch(`/api/risks${qs ? '?' + qs : ''}`);
};

export const updateRiskStatus = (id, status) =>
  apiFetch(`/api/risks/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) });
